export const BizChatSidepaneEnablementCodes = {
    BIZCHAT_SIDEPANE_ENABLED: 'Enabled',
    BIZCHAT_SIDEPANE_DISABLED_POLICY_BLOCK_ACCESS_TO_FILES: 'D_SidepaneAccessToFilesPolicy',
    BIZCHAT_SIDEPANE_DISABLED_OCPS_POLICY: 'D_SidepaneOCPSPolicy',
    BIZCHAT_SIDEPANE_ACQUISITION_NOT_FOUND: 'D_SidepaneAcquisitionNotFound',
    BIZCHAT_SIDEPANE_COPILOT_INELIGIBLE: 'D_SidepaneCopilotIneligible',
    BIZCHAT_SIDEPANE_DISABLED_VANITY_DOMAIN: 'D_SidepaneVanityDomain',
} as const;

export type BizChatSidepaneEnablementCode =
    typeof BizChatSidepaneEnablementCodes[keyof typeof BizChatSidepaneEnablementCodes];
